let validateEntName = (rule, value, callback) => {
	if(value === '') {
		callback(new Error('请输入企业名称'))
	} else {
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 100 ? callback(new Error('最大允许输入100个字符')) : callback()
	}
}
let validateRegNum = (rule, value, callback) => {
	if(value === '') {
		callback(new Error('请输入营业执照注册号'))
	} else if(!/(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/.test(value)) {
		callback(new Error('请输入正确的营业执照注册号'))
	} else {
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 100 ? callback(new Error('最大允许输入100个字符')) : callback()
	}
}
let validatePerName = (rule, value, callback) => {
	if(value === '') {
		callback(new Error('请输入真实姓名'))
	} else {
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 100 ? callback(new Error('最大允许输入100个字符')) : callback()
	}
}
let validateIdCard = (rule, value, callback) => {
	if(value === '') {
		callback(new Error('请输入证件号码'))
	} else if(!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value)) {
		callback(new Error('请输入正确的身份证号码'))
	} else {
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 100 ? callback(new Error('最大允许输入100个字符')) : callback()
	}
}
let validateTel = (rule, value, callback) => {
	if(value === '') {
		callback(new Error('请输入手机号码'))
	}else if (!/((13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])+\d{8})$/.test(value)) {
		callback(new Error('请输入正确的手机格式'))
	} else {
		callback()
	}
}

const rules = {
	entName: [
		{ validator: validateEntName , trigger: 'blur' }
	],
	entRegNum: [
		{ validator: validateRegNum , trigger: 'blur' }
	],
	perName: [
		{ validator: validatePerName , trigger: 'blur' }
	],
	perIdNum: [
		{ validator: validateIdCard , trigger: 'blur' }
	],
	tel: [
		{ validator: validateTel, trigger: 'blur' }
	]
}

export default rules
